// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecipeFilters_wrapper__RAAeu","criteria":"RecipeFilters_criteria__L4Zjv"};